export const CoverageSection = () => {
  return (
    <section
      className="relative w-full"
      data-testid="home-coverage-section"
    >
      {/* Desktop / tablet banner */}
      <img
        src="/assets/backgrounds/ban-cobertura.jpg"
        alt="Ofrecemos cobertura a nivel nacional"
        className="hidden sm:block w-full h-auto"
      />
      {/* Mobile banner */}
      <img
        src="/assets/backgrounds/ban-cobertura-mov.jpg"
        alt="Ofrecemos cobertura a nivel nacional"
        className="block sm:hidden w-full h-auto"
      />
    </section>
  );
};
